
import AdminAPIService from '@/modules/admin/services/apiService'

export default class AdminModule {
  constructor() {
  }

  install(Vue) {
     // Services
     Vue.prototype.$apiService.adminService = new AdminAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }


  getRoutes() {
    return [
      {
        path: '/admin/account',
        name: 'Account',
        component: () => import('@/modules/admin/views/account.vue'),
        meta: {
          requiresAuth: true,
          title: 'Company Account',
          menuLink: '/admin/account',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
      {
        path: '/admin/billing',
        name: 'Billing',
        component: () => import('@/modules/admin/views/accountBilling.vue'),
        meta: {
          requiresAuth: true,
          title: 'Billing',
          menuLink: '/admin/billing',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/admin/integrations',
        name: 'Integrations',
        component: () => import('@/modules/admin/views/integrationList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Integrations',
          menuLink: '/admin/integrations',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
      {
        path: '/admin/configuration',
        name: 'Configuration',
        component: () => import('@/modules/admin/views/generalConfig.vue'),
        meta: {
          requiresAuth: true,
          title: 'Configuration',
          menuLink: '/admin/configuration',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
      {
        path: '/admin/tools',
        name: 'AdminTools',
        component: () => import('@/modules/admin/views/adminTools.vue'),
        meta: {
          requiresAuth: true,
          title: 'Admin Tools',
          menuLink: '/admin/tools',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
      {
        path: '/admin/tools/accountbilling',
        name: 'AdminToolsSetupBilling',
        component: () => import('@/modules/admin/views/adminToolSetupBilling.vue'),
        meta: {
          requiresAuth: true,
          hideBreadcrumbs: true,
          title: 'Account Billing',
        }
      },
      {
        path: '/admin/tools/openingbalance/glass',
        name: 'AdminToolsGlassSetup',
        component: () => import('@/modules/admin/views/adminToolGlassSetup.vue'),
        meta: {
          requiresAuth: true,
          title: 'Opening Balance - Glass Setup',
          menuLink: '/admin/tools',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Admin', link: '/admin' },
            { title: 'Admin Tools', link: '/admin/tools' }
          ],
        }
      },
      {
        path: '/admin/tools/manualusage/glass',
        name: 'AdminToolGlassUsage',
        component: () => import('@/modules/admin/views/adminToolGlassUsage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Manual Usage - Glass Setup',
          menuLink: '/admin/tools',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Admin', link: '/admin' },
            { title: 'Admin Tools', link: '/admin/tools' }
          ],
        }
      },
      {
        path: '/admin/tools/import',
        name: 'AdminToolImport',
        component: () => import('@/modules/admin/views/adminToolImport.vue'),
        meta: {
          requiresAuth: true,
          title: 'Import',
          menuLink: '/admin/tools',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
      {
        path: '/admin/tools/export',
        name: 'AdminToolExport',
        component: () => import('@/modules/admin/views/adminToolExport.vue'),
        meta: {
          requiresAuth: true,
          title: 'Export',
          menuLink: '/admin/tools',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
      {
        path: '/admin/tools/movingaverage',
        name: 'AdminToolMovingAvgCalc',
        component: () => import('@/modules/admin/views/adminToolMovingAvgCalc.vue'),
        meta: {
          requiresAuth: true,
          title: 'Moving Average Calculator',
          menuLink: '/admin/tools',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Admin', link: '/admin' }
          ],
        }
      },
    ]
  }
}